import React from 'react';

import { JourneyAlias } from 'src/common/interfaces/journey/alias.interface';
import { apiDeleteJourneyAlias } from 'src/utils/journeyApi';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { generateJourneyAliasShareUrl } from 'src/utils/journey';
import { useCurrentOrganization } from 'src/store/organization';
import { Nullable } from 'src/types/nullable.type';
import SharePanelLinkListItem from './item';
import { useSharePanelStore } from 'src/common/store/share.store';
import { ShareContentCommonProps } from '../../content';

interface Props extends ShareContentCommonProps {
  aliases: JourneyAlias[];
  onAliasDelete: (alias: JourneyAlias) => void;
}

export const SharePanelLinkList = ({ aliases, onAliasUpdate, onAliasDelete }: Props) => {
  const { currentOrganization } = useCurrentOrganization();
  const { setSuccessNotification } = useNotificationMessage();

  const { pushLinkConfigType, setActiveAlias, setIsNewAlias } = useSharePanelStore((state) => ({
    pushLinkConfigType: state.pushLinkConfigType,
    setActiveAlias: state.setActiveAlias,
    setIsNewAlias: state.setIsNewAlias,
  }));

  const onLinkEdit = (alias: Nullable<JourneyAlias> = null) => {
    setActiveAlias(alias);
    setIsNewAlias(alias ? false : true);
    pushLinkConfigType('additional-link');
  };

  const onCreateLinkClicked = () => {
    onLinkEdit();
  };
  const onEditLinkClicked = (alias: JourneyAlias) => () => onLinkEdit(alias);

  const onCopyLinkClicked = async (alias: JourneyAlias) => {
    await navigator.clipboard.writeText(generateJourneyAliasShareUrl(currentOrganization, alias.slug));
    setSuccessNotification('URL copied to clipboard');
  };

  const onDeleteConfirm = (alias: JourneyAlias) => () => {
    apiDeleteJourneyAlias(alias.uuid).then(() => {
      onAliasDelete(alias);
    });
  };

  return (
    <div className='flex flex-col space-y-4'>
      {!aliases || aliases.length === 0 ? (
        <span className='text-bedrock-p'>
          Create additional links to have granular access controls on a per link basis.
        </span>
      ) : (
        aliases.map((alias) => (
          <SharePanelLinkListItem
            key={alias.id}
            alias={alias}
            onEditLinkClick={onEditLinkClicked}
            onDeleteConfirm={onDeleteConfirm}
            onCopyLinkClick={onCopyLinkClicked}
            onAliasUpdate={onAliasUpdate}
          />
        ))
      )}
      <button type='button' className='btn-bedrock-secondary' onClick={onCreateLinkClicked}>
        New link
      </button>
      {/* {thumbnailElement && <div className='absolute -z-40'>{thumbnailElement}</div>} */}
    </div>
  );
};
